import type { Ref } from 'vue';
import {
  computed,
} from 'vue';

import {
  TRANSLATION_GROUP_DASHBOARD_ADMIN,
  TRANSLATION_GROUP_DASHBOARD_AFFILIATE,
} from '@modules/dashboard/constants';
import { useCurrentNamespace } from '@modules/permissions/composables';

export interface DashboardTranslationGroupComposable {
  translationGroup: Ref<
    typeof TRANSLATION_GROUP_DASHBOARD_ADMIN |
    typeof TRANSLATION_GROUP_DASHBOARD_AFFILIATE
  >;
}

export default function useDashboardTranslationGroup(): DashboardTranslationGroupComposable {
  const { isAffiliateNamespace } = useCurrentNamespace();
  const translationGroup = computed(() => (
    isAffiliateNamespace.value
      ? TRANSLATION_GROUP_DASHBOARD_AFFILIATE
      : TRANSLATION_GROUP_DASHBOARD_ADMIN
  ));

  return {
    translationGroup,
  };
}
